var React = require('react');

function IconCross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.0879 0L9.99966 5.08964L4.91002 0H0V4.91002L5.08964 10.0003L0 15.09V20.0007H4.91002L9.99966 14.9104L15.0879 20.0007H20V15.09L14.9104 10.0003L20 4.91002V0H15.0879Z","fill":"#0B1C63"}));
}

IconCross.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconCross;

IconCross.default = IconCross;
